/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-09-28 10:25:26
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-12-15 14:34:59
 * @FilePath: \mpc-3\apps\mpc-external\src\components\blockDrawerClose.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useDrawerState } from '../model/drawerState'
import { Modal } from '@bedrock/components'

export const blockDrawerClose = (onOk: () => any) => {
  const { isDrawerEditing, setIsDrawerEditing, blockModalConfig } = useDrawerState.getState()

  if (!isDrawerEditing) {
    return onOk?.()
  }

  return new Promise((resolve) => {
    Modal.warning({
      title: blockModalConfig?.title || '确定离开当前填写表单吗？',
      content: blockModalConfig?.content || '离开后，未提交的内容将会丢失',
      onOk: () => {
          onOk?.()
          setIsDrawerEditing(false)
          resolve(true)
          return Promise.resolve(true)
        }
      })
  })
}
export default blockDrawerClose;
